import { render, staticRenderFns } from "./WaMessageView.vue?vue&type=template&id=b6c7fe7a"
import script from "./WaMessageView.vue?vue&type=script&lang=js"
export * from "./WaMessageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports